import { Link } from 'react-router-dom';

import {
  StyledFooterWrapper,
  StyledFooter,
  StyledFooterItem,
  StyledFooterContacts,
  StyledFooterContactsWrapper,
  StyledCopyright,
  StyledFooterContent,
} from './StyledFooter';

import { ReactComponent as PlusIcon } from '../../Static/icons/plus.svg';

import { Socials } from '../Header';

import { footerConfig } from '../../Configs/FooterConfig';
import { constants } from '../../Configs/constants';

const {
  CATEGORIES,
  urls: { OBJECTS },
} = constants;

export const Footer = () => {
  const handleClick = e =>
    e.target
      .closest('li')
      .querySelector('.expandable')
      .classList.toggle('expanded');
  return (
    <StyledFooter id="kontaktai">
      <StyledFooterWrapper as="ul">
        <StyledFooterItem>
          <h2>MŪSŲ OBJEKTAI</h2>
          <StyledFooterContent className="expandable">
            {CATEGORIES.map(({ name, link }, i) => {
              return i ? (
                <li className="text" key={i}>
                  <Link to={`${OBJECTS}/${link}`} className="link">
                    {name}
                  </Link>
                </li>
              ) : null;
            })}
          </StyledFooterContent>
          <PlusIcon className="plus_icon" onClick={handleClick} />
        </StyledFooterItem>
        <StyledFooterItem>
          <h2>KONTAKTAI</h2>
          <StyledFooterContacts as="address">
            <StyledFooterContactsWrapper>
              <li>UAB „Tikės grupė“</li>
              <li>Dubysos g. 60, Klaipėda</li>
              <li>
                <a className="link" href="tel:+37068121500">
                  +370 681 21500
                </a>
              </li>
              <li>
                <a className="link" href="mailto:info@tikesgrupe.lt">
                  info@tikesgrupe.lt
                </a>
              </li>
            </StyledFooterContactsWrapper>
            <Socials className="socials--desktop" />
          </StyledFooterContacts>
        </StyledFooterItem>
        <StyledFooterItem>
          <h2>Rekvezitai</h2>
          <StyledFooterContent className="expandable">
            {footerConfig.payments.map((text, i) => (
              <li className="text" key={i}>
                {text}
              </li>
            ))}
          </StyledFooterContent>
          <PlusIcon className="plus_icon" onClick={handleClick} />
        </StyledFooterItem>
        <StyledFooterItem>
          <h2>Darbo laikas</h2>
          <StyledFooterContent style={{ marginBottom: '18px' }}>
            <li className="text">PN - 3 BIR - 10:44 AM</li>
            <li className="text">PN - 3 BIR - 10:44 AM</li>
            <li className="text">PN - 3 BIR - 10:44 AM</li>
            <li className="text">PN - 3 BIR - 10:44 AM</li>
            <li className="text">PN - 3 BIR - 10:44 AM</li>
          </StyledFooterContent>
        </StyledFooterItem>
      </StyledFooterWrapper>
      <StyledCopyright>
        © 2019 TikesGrupe.lt | Be UAB Tikės grupė sutikimo draudžiama kopijuoti
        ir platinti svetainėje esančią informaciją.
      </StyledCopyright>
    </StyledFooter>
  );
};
